
import Navigation from './components/Navigation';
import PrivacyHero from './components/PrivacyHero';
import DataFlow from './components/DataFlow';
import EphemeralInfrastructure from './components/EphemeralInfrastructure';
import WhatWeStore from './components/WhatWeStore';
import ZeroRetention from './components/ZeroRetention';
import EncryptionSpecs from './components/EncryptionSpecs';
import Subpoena from './components/Subpoena';
import LocalCache from './components/LocalCache';
import Commitment from './components/Commitment';
import ComplianceReadiness from './components/ComplianceReadiness';
import PrivacyFooter from './components/PrivacyFooter';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      <Navigation />
      <PrivacyHero />
      <DataFlow />
      <EphemeralInfrastructure />
      <WhatWeStore />
      <ZeroRetention />
      <EncryptionSpecs />
      <Subpoena />
      <LocalCache />
      <Commitment />
      <ComplianceReadiness />
      <PrivacyFooter />
    </div>
  );
}
